module.exports = __webpack_public_path__ + "/images/shop/icon/paper_plane.svg";